import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]
  static values = { src: String }

  open() {
    if (!this.frameTarget.src) {
      this.frameTarget.src = this.srcValue
    }
  }
}
